// src/pages/About/index.jsx
import React, { useState } from 'react';
import { Layout, Modal, Form, Input, Button, Typography, Divider } from 'antd';
import AppHeader from '../../components/header';
import AppFooter from '../../components/footer';
import './index.css';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const About = ({ aboutInfo, onUpdateAboutInfo, loggedInUser, onLogout }) => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [form] = Form.useForm();

  // 打开编辑模态框
  const handleOpenEditModal = () => {
    form.setFieldsValue(aboutInfo);
    setEditModalVisible(true);
  };

  // 关闭编辑模态框
  const handleCloseEditModal = () => {
    setEditModalVisible(false);
  };

  // 保存编辑内容
  const handleSaveEdit = () => {
    form.validateFields().then(values => {
      onUpdateAboutInfo(values);
      handleCloseEditModal();
    });
  };

  // 取消编辑
  const handleCancelEdit = () => {
    handleCloseEditModal();
  };

  return (
    <Layout className="blog-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />
      
      <Content className="about-content">
        <div className="about-container">
          <div className="about-header">
            <Title level={1} className="about-title">关于我</Title>
            <Paragraph className="about-subtitle">了解博主的更多信息</Paragraph>
          </div>
          
          <div className="about-card">
            {/* 用户头像 */}
            <div className="avatar-container">
              <img src={aboutInfo.avatar || '/default-avatar.png'} alt="Avatar" className="avatar" />
            </div>

            {/* 标题 */}
            <Title level={2} className="greeting">Hi，我是 {aboutInfo.name}！</Title>

            {/* 描述 */}
            <Paragraph className="description">{aboutInfo.intro || '这个人很神秘，什么也没留下。'}</Paragraph>
            <Paragraph className="welcome">{aboutInfo.details || '欢迎来到我的博客！请登陆后完善您的个人信息！'}</Paragraph>

            <Divider />

            {/* 信息列表 */}
            <div className="info-list">
              <div className="info-item">
                <span className="label">邮箱</span>
                <span className="value">{aboutInfo.email || '暂无'}</span>
              </div>
              <div className="info-item">
                <span className="label">技术栈</span>
                <span className="value">{aboutInfo.techStack || '暂无'}</span>
              </div>
              <div className="info-item">
                <span className="label">兴趣爱好</span>
                <span className="value">{aboutInfo.hobbies || '暂无'}</span>
              </div>
              <div className="info-item">
                <span className="label">GitHub 链接</span>
                <span className="value">{aboutInfo.github || '#'}</span>
              </div>
              <div className="info-item">
                <span className="label">个人主页链接</span>
                <span className="value">{aboutInfo.personalHomepage || '#'}</span>
              </div>
            </div>

            {/* 编辑按钮 */}
            {loggedInUser && (
              <Button type="primary" onClick={handleOpenEditModal} className="edit-btn">
                🖋️ 编辑个人信息
              </Button>
            )}
          </div>
        </div>
      </Content>

      {/* 编辑模态框 */}
      <Modal
        title="编辑个人信息"
        open={editModalVisible}
        onOk={handleSaveEdit}
        onCancel={handleCancelEdit}
        okText="保存"
        cancelText="取消"
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="姓名"
            name="name"
            rules={[{ required: true, message: '请输入姓名!' }]}
          >
            <Input placeholder="请输入姓名" />
          </Form.Item>

          <Form.Item
            label="头像链接"
            name="avatar"
          >
            <Input placeholder="请输入头像链接" />
          </Form.Item>

          <Form.Item
            label="简介"
            name="intro"
            rules={[{ required: true, message: '请输入简介!' }]}
          >
            <Input.TextArea rows={3} placeholder="请输入个人简介" />
          </Form.Item>

          <Form.Item
            label="详细介绍"
            name="details"
            rules={[{ required: true, message: '请输入详细信息!' }]}
          >
            <Input.TextArea rows={4} placeholder="请输入详细信息" />
          </Form.Item>

          <Form.Item
            label="邮箱"
            name="email"
            rules={[
              { required: true, message: '请输入邮箱!' },
              { type: 'email', message: '邮箱格式不正确!' }
            ]}
          >
            <Input placeholder="请输入邮箱" />
          </Form.Item>

          <Form.Item
            label="技术栈"
            name="techStack"
          >
            <Input placeholder="请输入技术栈，如：React, JavaScript, Node.js" />
          </Form.Item>

          <Form.Item
            label="兴趣爱好"
            name="hobbies"
          >
            <Input placeholder="请输入兴趣爱好" />
          </Form.Item>

          <Form.Item
            label="GitHub 链接"
            name="github"
          >
            <Input placeholder="请输入 GitHub 链接" />
          </Form.Item>

          <Form.Item
            label="个人主页链接"
            name="personalHomepage"
          >
            <Input placeholder="请输入个人主页链接" />
          </Form.Item>
        </Form>
      </Modal>
      
      <AppFooter />
    </Layout>
  );
};

export default About;